import React from 'react'

import s from './styles.module.scss'

import TooltipAnonymous from './TooltipAnonymous'

const ContentAnonymous = ({
  content = '',
  displayTooltip = false,
}: {
  content?: string
  displayTooltip?: boolean
}) => {
  return (
    <div className={s.container}>
      {content}
      {displayTooltip && <TooltipAnonymous />}
    </div>
  )
}

export default ContentAnonymous
